import React, { Component } from 'react';

class Blank extends Component {
  render() {
    return this.props.children
  }
}

export default Blank
